import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      dark_50: { main: dark50 } = {},
      gray_400: { main: gray400 } = {},
      white_100: { main: white100 } = {},
      dark_stroke: { main: darkStroke } = {},
      gray_stroke: { main: grayStroke } = {},
      red_100: { main: red100 } = {},

    } = {}
  } = theme

  return {
    dialogTitle: {
      color: blue300
    },
    description: {
      color: isDark ? dark50 : gray400
    },
    sectionTitle: {
      color: blue300,
      fontWeight: 'bold'
    },
    inputWrapper: {
      display: 'flex',
      gap: '8px'
    },
    boxSwitch: {
      border: isDark ? `1px solid ${darkStroke}` : `1px solid ${grayStroke}`,
      padding: '8px',
      borderRadius: '12px',
      '&> span': {
        marginLeft: '40px',
        fontWeight: 'bold',
        color: blue300
      }
    },
    iconButtonDelete: {
      padding: '6px',
      borderRadius: 8,
      color: red100,
      '&:hover': {
        backgroundColor: red100,
        color: white100
      }
    },
    dialogActions: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    actionButtons: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    },

    contentTitleUser: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    sendLinkButton: {
      color: isDark ? dark50 : gray400,
      backgroundColor: 'transparent !important',
      '& :hover': {
        backgroundColor: 'transparent !important',
        color: blue300
      }
    }
  }
})
